import UploadComponent from "../../components/upload-page/upload.component"


const UploadPage = () => {
    return <UploadComponent />
}

export default UploadPage;